import BaseError from "./BaseError"
/* 
 * An error from calling fetch() that can be used with other
 * aspects of this app.
 */
export default class FetchError extends BaseError {
}
